import PropTypes from "prop-types";
import React from "react";

const ProgressBar = ({
  percentage = 0
}) => {
  return (
    <svg width="100%" height="4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="4" fill="#787880" fillOpacity="0.16"/>
      <rect width={`${percentage}%`} height="4" rx="2" fill="#007AFF"/>
    </svg>
  );
}

ProgressBar.propTypes = {
  percentage: PropTypes.number
}

export default ProgressBar;